var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatePicker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 63,
    viewBox: "0 0 81 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13.5H66.5C68.1569 13.5 69.5 14.8431 69.5 16.5V46.5C69.5 48.1569 68.1569 49.5 66.5 49.5H14.5C12.8431 49.5 11.5 48.1569 11.5 46.5V16.5C11.5 14.8431 12.8431 13.5 14.5 13.5Z",
    stroke: "#E6EAEB",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11.5C18.5 9.84315 19.8431 8.5 21.5 8.5C23.1569 8.5 24.5 9.84315 24.5 11.5V12.5H56.5V11.5C56.5 9.84315 57.8431 8.5 59.5 8.5C61.1569 8.5 62.5 9.84315 62.5 11.5V12.5H66.5C68.7091 12.5 70.5 14.2909 70.5 16.5V22.5H10.5V16.5C10.5 14.2909 12.2909 12.5 14.5 12.5H18.5V11.5Z",
    fill: "#80959B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.45,
    cy: 31.5469,
    r: 3,
    fill: "#E6EAEB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1499,
    cy: 31.5469,
    r: 3,
    fill: "#E6EAEB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.8501,
    cy: 31.5469,
    r: 3,
    fill: "#E6EAEB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.55,
    cy: 31.5469,
    r: 3,
    fill: "#E6EAEB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.45,
    cy: 41.5469,
    r: 3,
    fill: "#E6EAEB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1499,
    cy: 41.5469,
    r: 3,
    fill: "#E6EAEB"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.8501,
    cy: 41.5469,
    r: 3,
    fill: "#E6EAEB"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.55,
    cy: 41.5469,
    r: 3,
    fill: "#80959B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePicker);
export default __webpack_public_path__ + "static/media/DatePicker.aeefd12b75b6bffe6bdc967e612831f0.svg";
export { ForwardRef as ReactComponent };